module.exports = __webpack_public_path__ + "media/reskin-images/icon--copy-745449c2.svg";